import { useState } from "react";
import { useGuid } from "../../../utilities/useGuid";

export const useCustomDataTableFeatures = () => {
    const guid = useGuid();

    const [clearSelectionToken, setClearSelectionToken] = useState<string>(guid.newGuid());

    const clearSelection = () => {
        setClearSelectionToken(guid.newGuid());
    };

    return {
        clearSelection,
        tableProps: {
            clearSelectionToken,
        },
    };
};
